import GraphicsTableHelper from "./graphic-table-helper";
import GraphicRulesTableHelper from "./graphic-rule-table-helper";

const GraphicsHelpers = {
  TableMain: GraphicsTableHelper,
  TableRules: GraphicRulesTableHelper,
};

export default GraphicsHelpers;
